module.exports = __webpack_public_path__ + "static/media/midwestjs-optimized.5240b8ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/98-demo/images/midwestjs-optimized.jpg
// module id = 975
// module chunks = 0